import { detectSourceFormat } from './detection';
import { cleanPlainText } from './text-cleaning';
import { createStats } from './stats';
import { sanitizeHtml } from './sanitize';
import { escapeHtml, htmlToMarkdown, htmlToPlainText, htmlToWhatsApp, markdownToHtml, plainTextToHtml } from './html-conversion';
import type { CleaningOptions, InputSnapshot, OutputMode, TransformResult } from '../types/app';

export function transform(snapshot: InputSnapshot, mode: OutputMode, options: CleaningOptions): TransformResult {
  const stats = createStats();
  const detected = detectSourceFormat(snapshot.plainText, snapshot.rawHtml);
  const sourceFormat = snapshot.sourceOverride === 'auto' ? detected.format : snapshot.sourceOverride;
  const cleanedPlainText = cleanPlainText(snapshot.plainText, options, stats);
  const simplifyHtml = options.removeUnnecessaryHtml || mode === 'email' || mode === 'html';

  let canonicalHtml: string;
  if ((sourceFormat === 'html' || sourceFormat === 'office') && snapshot.rawHtml.trim()) {
    canonicalHtml = sanitizeHtml(snapshot.rawHtml, stats, simplifyHtml);
  } else if (sourceFormat === 'markdown' && options.convertMarkdown) {
    canonicalHtml = markdownToHtml(cleanedPlainText, stats);
  } else {
    canonicalHtml = plainTextToHtml(cleanedPlainText, options.detectLists, stats);
  }
  canonicalHtml = sanitizeHtml(canonicalHtml, undefined, simplifyHtml);

  let html = canonicalHtml;
  let text = htmlToPlainText(canonicalHtml);
  if (mode === 'whatsapp') {
    text = htmlToWhatsApp(canonicalHtml);
    html = `<pre>${escapeHtml(text)}</pre>`;
  } else if (mode === 'plain') {
    text = htmlToPlainText(canonicalHtml);
    html = `<pre>${escapeHtml(text)}</pre>`;
  } else if (mode === 'markdown') {
    text = htmlToMarkdown(canonicalHtml);
    html = `<pre>${escapeHtml(text)}</pre>`;
  } else if (mode === 'html') {
    text = canonicalHtml;
  }

  return { mode, html: sanitizeHtml(html, undefined, simplifyHtml), text, canonicalHtml, cleanedPlainText, detected, stats };
}
